module.exports = __webpack_public_path__ + "img/gonzalo-salse.86c4bcfe.jpg";